import Login from "../Views/Auth/Login"

const PublicRoutes = [
  {
    path: '/login',
    component: <Login />
  }
]


export default PublicRoutes;